<template>
    <div class="main-box">
        <pageNav :frameAnimated="frameAnimated" :screenIndex="screenIndex" 
            @hideContent="hideContent" @navKnowledgeSearch="navKnowledgeSearch" @logoFun="logoFun"
        />
        <picFrame v-show="!frameAnimated" @animatedCallback="animatedCallback" />
        <v-fullpage ref="fullpage" class="full-main" @leaveSlide="leaveSlide">
            <FirstScreen slot="section" :frameAnimated="frameAnimated" :visible="visible" @showSearch="showSearch" :showContent="showContent" :focusChange="focusChange"/>
            <SecondScreen slot="section" :screenIndex="screenIndex" :showContent="showContent" 
                @fullpageStop="fullpageStop" @fullpageStart="fullpageStart" @exitFullScreen="exitFullScreen"/>
        </v-fullpage>
        <slideArrow v-if="frameAnimated" :screenIndex="screenIndex" @next="nextPage"/>
        <searchTab :visible="visible" @hideSearch="hideSearch" @getTabIndex="getTabIndex" :navKnowledge="navKnowledge" :navAdvanced="navAdvanced"/>
        <confirmModal :confirmVisible="confirmVisible" @ok="hideModal" />
    </div>
</template>

<script>
    import pageNav from '../../components/nav'
    import picFrame from "./sections/picFrame"
    import FirstScreen from './sections/firstScreen'
    import SecondScreen from './sections/secondScreen'
    import slideArrow from '../../components/sildeArrow'
    import searchTab from '../../components/searchTab'
    import confirmModal from '../../components/confirmModal'
    export default {
        components:{
            pageNav,
            FirstScreen,
            picFrame,
            SecondScreen,
            searchTab,
            slideArrow,
            confirmModal
        },
        data(){
            return{
                navKnowledge: 0, // 导航栏知识检索
                navAdvanced : 0, // 导航栏高级检索
                homeInfo:{},
                loading:true,
                frameAnimated:false,
                screenIndex:1,
                visible:false,
                showContent:true,
                childTabIndex: 0,
                focusChange: 0, // 首页检索框焦点改变
                confirmVisible: false, // 确认框
            }
        },
        mounted(){
            this.$nextTick(()=>{
                this.esc(this, 0); // 监听esc按键
            })
        },
        watch:{
            frameAnimated() {
                // let isExplain = this.getCookie('isExplain');
                if (this.frameAnimated) {
                    setTimeout(()=> {
                        this.confirmVisible = true;
                    }, 500)
                }
            }
        },
        methods:{
            hideModal(){
                this.confirmVisible = false;
                // this.setCookie('isExplain', true, 3600);
            },
            logoFun(){ // logo点击
                this.$refs['fullpage'].pre()
            },
            navKnowledgeSearch(){ // 导航栏知识检索
                this.navKnowledge = new Date().getTime();
                this.visible=true;
            },
            leaveSlide(e){
                this.screenIndex=e.currentIndex;
                if(e.currentIndex == 2) this.focusChange = new Date().getTime();
            },
            animatedCallback(){
                this.frameAnimated=true;
            },
            exitFullScreen(val){ // 电影页面影戏院地图退出全屏时
                if(!val) this.$refs['fullpage'].initFullPage()
            },
            fullpageStart(val){ // 启动鼠标滚轮滚动
                this.$refs['fullpage'].setAllowScrolling(val)
            },
            fullpageStop(val){ // 停止鼠标滚轮滚动
                this.$refs['fullpage'].setAllowScrolling(val)
            },
            nextPage(){
                this.$refs['fullpage'].next()
            },
            prevPage(val){
                this.$refs['fullpage'].pre()
            },
            hideContent(){
                this.showContent=!this.showContent
            },
            showSearch(){
                this.visible=true;
                this.navAdvanced = new Date().getTime();
            },
            hideSearch(){
                this.visible=false;
            },
            getTabIndex(index){
                this.childTabIndex = index;
            },
        }
    }
</script>

<style scoped lang="less">
    .main-box{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }
</style>
